import { BaseEntity } from "../../contracts";

export const uniqueElementsById = <T extends BaseEntity>(entities: T[]): T[] => {
    return entities.filter((entity, index, self) =>
        self.findIndex(e => e.id === entity.id) === index);
}